import type React from 'react'
import {LABELS} from '../constants/labels'

import {LabelDots} from './LabelDots'
import {SharedPicker} from './SharedPicker'
import {type SafeHTMLString, SafeHTMLText} from '@github-ui/safe-html'

type CompressedLabelAnchorProps = {
  size?: 'small' | 'large'
  labelNamesWithColor: Array<{nameHTML: string; color: string}>
  anchorProps?: React.HTMLAttributes<HTMLElement>
  MAX_DISPLAYED_LABELS?: number
  readonly?: boolean
}

export const CompressedLabelsToken = ({
  size = 'large',
  labelNamesWithColor,
  anchorProps,
  MAX_DISPLAYED_LABELS = 5,
  readonly,
}: CompressedLabelAnchorProps) => {
  return (
    <SharedPicker
      anchorProps={anchorProps}
      readonly={readonly}
      label={labelNamesWithColor.length > 1 ? LABELS.labels : LABELS.noLabels}
      sharedPickerMainValue={
        <LabelNames labelNamesWithColor={labelNamesWithColor} MAX_DISPLAYED_LABELS={MAX_DISPLAYED_LABELS} />
      }
      leadingIconElement={
        labelNamesWithColor.length > 0 && (
          <LabelDots MAX_DISPLAYED_LABELS={MAX_DISPLAYED_LABELS} labelColors={labelNamesWithColor.map(l => l.color)} />
        )
      }
      ariaLabel={LABELS.selectLabels}
      size={size}
    />
  )
}

const LabelNames = ({labelNamesWithColor, MAX_DISPLAYED_LABELS = 5}: CompressedLabelAnchorProps) => {
  return (
    <SafeHTMLText
      html={
        labelNamesWithColor
          .slice(0, MAX_DISPLAYED_LABELS)
          .map(a => a.nameHTML)
          .join(', ')
          .concat(
            labelNamesWithColor.length > MAX_DISPLAYED_LABELS
              ? `, ${labelNamesWithColor.length - MAX_DISPLAYED_LABELS}+`
              : '',
          ) as SafeHTMLString
      }
    />
  )
}

try{ CompressedLabelsToken.displayName ||= 'CompressedLabelsToken' } catch {}
try{ LabelNames.displayName ||= 'LabelNames' } catch {}